module.exports = __webpack_public_path__ + "static/starCharge/img/loading.892fe0d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/starcharge/assets/img/loading.gif
// module id = EDr7
// module chunks = 81